import api from '../axiosConfig';
import { SUPPLIERS } from '../config/apiEndpoints';

export const SupplierService = {
    /**
     * List all suppliers
     * GET /api/v1/suppliers
     * x-tenant-id header is automatically attached via axios interceptor
     */
    getSuppliers: async (params = {}) => {
        try {
            const axiosParams = { ...params };
            if (params.page !== undefined) {
                axiosParams.page = params.page + 1;
            } else if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                axiosParams.noPagination = true;
            }
            const response = await api.get(SUPPLIERS.BASE, { params: axiosParams });
            if (params.page !== undefined) return response.data;
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('SupplierService getSuppliers error:', error);
            throw error;
        }
    },

    /**
     * Create a new supplier
     * POST /api/v1/suppliers
     * @param {Object} data - Supplier payload
     */
    createSupplier: async (data) => {
        try {
            const response = await api.post(SUPPLIERS.BASE, data);
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('SupplierService createSupplier error:', error);
            throw error;
        }
    },

    /**
     * Get a supplier by ID
     * GET /api/v1/suppliers/:id
     * @param {string} id - Supplier ID
     */
    getSupplierById: async (id) => {
        try {
            const response = await api.get(SUPPLIERS.BY_ID(id));
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('SupplierService getSupplierById error:', error);
            throw error;
        }
    },

    /**
     * Update a supplier
     * PUT /api/v1/suppliers/:id
     * @param {string} id - Supplier ID
     * @param {Object} data - Update payload (contactPerson, email)
     */
    updateSupplier: async (id, data) => {
        try {
            const response = await api.put(SUPPLIERS.BY_ID(id), data);
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('SupplierService updateSupplier error:', error);
            throw error;
        }
    },

    /**
     * Delete a supplier
     * DELETE /api/v1/suppliers/:id
     * @param {string} id - Supplier ID
     */
    deleteSupplier: async (id) => {
        try {
            const response = await api.delete(SUPPLIERS.BY_ID(id));
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('SupplierService deleteSupplier error:', error);
            throw error;
        }
    }
};
